/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;



//////////////////
// WEBPACK FOOTER
// ./node_modules/history/lib/ExecutionEnvironment.js
// module id = 193
// module chunks = 76